module.exports = __webpack_public_path__ + "img/css3.39599ada.svg";